// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"38b67ba8","180":"8e88b568","453":"63c22242","588":"fb95e0e4","644":"ba116dc3","884":"caa78666"}[chunkId] + ".chunk.js";
};